export const posts = [
  {
    "slug": "january-hours-2026-2026-01-05",
    "title": "Read the January 2026 hours on the door and the listing, January 5, 2026",
    "seoTitle": "January 2026 hours (salon, January 5, 2026)",
    "description": "January 2026 hours for a salon on January 5, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-01-05",
    "cta": "This week, look at the hours for January 2026. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In January 2026, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This January 5, 2026 note is for a salon. The check is January 2026 hours: the hours for January 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for January 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for January 2026. In January 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for January 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for January 2026 before you add anything",
        "paragraphs": [
          "A mismatch on January 2026 hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the hours for January 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set New Year hours before the week starts, December 29, 2025",
        "href": "/blog/new-year-hours-2026-2025-12-29"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "january-photo-2026-2026-01-12",
    "title": "Add one January 2026 photo of the real place, January 12, 2026",
    "seoTitle": "January 2026 business photo (clinic, January 12, 2026)",
    "description": "January 2026 business photo for a clinic on January 12, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-01-12",
    "cta": "This week, look at a photo from January 2026. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this January of the door, the work, or the counter. A photo from another season makes 2026 look unattended.",
          "This January 12, 2026 note is for a clinic. The check is January 2026 business photo: a photo from January 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from January 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from January 2026. In January 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from January 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from January 2026 before you add anything",
        "paragraphs": [
          "A mismatch on January 2026 business photo is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a photo from January 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the January 2026 hours on the door and the listing, January 5, 2026",
        "href": "/blog/january-hours-2026-2026-01-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "january-offer-2026-2026-01-19",
    "title": "Keep the January 2026 offer to a single dated line, January 19, 2026",
    "seoTitle": "January 2026 offer (restaurant, January 19, 2026)",
    "description": "January 2026 offer for a restaurant on January 19, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-01-19",
    "cta": "This week, look at the offer running in January 2026. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in January 2026, put the end date in the same sentence and keep it under the phone number.",
          "This January 19, 2026 note is for a restaurant. The check is January 2026 offer: the offer running in January 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in January 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in January 2026. In January 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in January 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in January 2026 before you add anything",
        "paragraphs": [
          "A mismatch on January 2026 offer is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the offer running in January 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the October 2025 offer to a single dated line, October 20, 2025",
        "href": "/blog/october-offer-2025-2025-10-20"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "january-list-2026-2026-01-26",
    "title": "Update the January 2026 menu or service list, January 26, 2026",
    "seoTitle": "January 2026 service list (law office, January 26, 2026)",
    "description": "January 2026 service list for a law office on January 26, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-01-26",
    "cta": "This week, look at what you offer in January 2026. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The list should be what you can do this January, typed out so a phone can read it. Remove anything 2026 has already dropped.",
          "This January 26, 2026 note is for a law office. The check is January 2026 service list: what you offer in January 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what you offer in January 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what you offer in January 2026. In January 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What you offer in January 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what you offer in January 2026 before you add anything",
        "paragraphs": [
          "A mismatch on January 2026 service list is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare what you offer in January 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish the December menu people are ordering from, December 1, 2025",
        "href": "/blog/december-menu-2025-12-01"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "february-form-fields-2026-02-02",
    "title": "Ask only what February bookings need, February 2, 2026",
    "seoTitle": "Short booking form (retail shop, February 2, 2026)",
    "description": "Short booking form for a retail shop on February 2, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-02-02",
    "cta": "This week, look at the fields on the form. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Name, number, the day they want, and the job. A long form in a short month is a form people abandon.",
          "This February 2, 2026 note is for a retail shop. The check is short booking form: the fields on the form, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the fields on the form",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the fields on the form. In February 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The fields on the form on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the fields on the form before you add anything",
        "paragraphs": [
          "A mismatch on short booking form is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the fields on the form. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Make sure the form matches a spring booking, March 3, 2025",
        "href": "/blog/march-form-2025-03-03"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "valentine-hours-2026-2026-02-09",
    "title": "Put Valentine's week hours and the offer in one place, February 9, 2026",
    "seoTitle": "Valentine's week hours (contractor, February 9, 2026)",
    "description": "Valentine's week hours for a contractor on February 9, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-02-09",
    "cta": "This week, look at Valentine's week. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If 2026 includes a Valentine offer or a fuller book, say the hours and the last day of the offer. Leave the business name alone.",
          "This February 9, 2026 note is for a contractor. The check is Valentine's week hours: Valentine's week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Valentine's week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Valentine's week. In February 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Valentine's week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Valentine's week before you add anything",
        "paragraphs": [
          "A mismatch on Valentine's week hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Valentine's week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one January 2026 photo of the real place, January 12, 2026",
        "href": "/blog/january-photo-2026-2026-01-12"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "february-hours-2026-2026-02-16",
    "title": "Read the February 2026 hours on the door and the listing, February 16, 2026",
    "seoTitle": "February 2026 hours (salon, February 16, 2026)",
    "description": "February 2026 hours for a salon on February 16, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-02-16",
    "cta": "This week, look at the hours for February 2026. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In February 2026, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This February 16, 2026 note is for a salon. The check is February 2026 hours: the hours for February 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for February 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for February 2026. In February 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for February 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for February 2026 before you add anything",
        "paragraphs": [
          "A mismatch on February 2026 hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the hours for February 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put Valentine's week hours and the offer in one place, February 9, 2026",
        "href": "/blog/valentine-hours-2026-2026-02-09"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "february-photo-2026-2026-02-23",
    "title": "Add one February 2026 photo of the real place, February 23, 2026",
    "seoTitle": "February 2026 business photo (clinic, February 23, 2026)",
    "description": "February 2026 business photo for a clinic on February 23, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-02-23",
    "cta": "This week, look at a photo from February 2026. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this February of the door, the work, or the counter. A photo from another season makes 2026 look unattended.",
          "This February 23, 2026 note is for a clinic. The check is February 2026 business photo: a photo from February 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from February 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from February 2026. In February 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from February 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from February 2026 before you add anything",
        "paragraphs": [
          "A mismatch on February 2026 business photo is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a photo from February 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the February 2026 hours on the door and the listing, February 16, 2026",
        "href": "/blog/february-hours-2026-2026-02-16"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "march-hours-2026-2026-03-02",
    "title": "Read the March 2026 hours on the door and the listing, March 2, 2026",
    "seoTitle": "March 2026 hours (restaurant, March 2, 2026)",
    "description": "March 2026 hours for a restaurant on March 2, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-03-02",
    "cta": "This week, look at the hours for March 2026. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In March 2026, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This March 2, 2026 note is for a restaurant. The check is March 2026 hours: the hours for March 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for March 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for March 2026. In March 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for March 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for March 2026 before you add anything",
        "paragraphs": [
          "A mismatch on March 2026 hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the hours for March 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one February 2026 photo of the real place, February 23, 2026",
        "href": "/blog/february-photo-2026-2026-02-23"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "march-photo-2026-2026-03-09",
    "title": "Add one March 2026 photo of the real place, March 9, 2026",
    "seoTitle": "March 2026 business photo (law office, March 9, 2026)",
    "description": "March 2026 business photo for a law office on March 9, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-03-09",
    "cta": "This week, look at a photo from March 2026. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this March of the door, the work, or the counter. A photo from another season makes 2026 look unattended.",
          "This March 9, 2026 note is for a law office. The check is March 2026 business photo: a photo from March 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from March 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from March 2026. In March 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from March 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from March 2026 before you add anything",
        "paragraphs": [
          "A mismatch on March 2026 business photo is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare a photo from March 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the March 2026 hours on the door and the listing, March 2, 2026",
        "href": "/blog/march-hours-2026-2026-03-02"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "march-offer-2026-2026-03-16",
    "title": "Keep the March 2026 offer to a single dated line, March 16, 2026",
    "seoTitle": "March 2026 offer (retail shop, March 16, 2026)",
    "description": "March 2026 offer for a retail shop on March 16, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-03-16",
    "cta": "This week, look at the offer running in March 2026. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in March 2026, put the end date in the same sentence and keep it under the phone number.",
          "This March 16, 2026 note is for a retail shop. The check is March 2026 offer: the offer running in March 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in March 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in March 2026. In March 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in March 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in March 2026 before you add anything",
        "paragraphs": [
          "A mismatch on March 2026 offer is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the offer running in March 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the January 2026 offer to a single dated line, January 19, 2026",
        "href": "/blog/january-offer-2026-2026-01-19"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "march-list-2026-2026-03-23",
    "title": "Update the March 2026 menu or service list, March 23, 2026",
    "seoTitle": "March 2026 service list (contractor, March 23, 2026)",
    "description": "March 2026 service list for a contractor on March 23, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-03-23",
    "cta": "This week, look at what you offer in March 2026. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The list should be what you can do this March, typed out so a phone can read it. Remove anything 2026 has already dropped.",
          "This March 23, 2026 note is for a contractor. The check is March 2026 service list: what you offer in March 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what you offer in March 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what you offer in March 2026. In March 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What you offer in March 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what you offer in March 2026 before you add anything",
        "paragraphs": [
          "A mismatch on March 2026 service list is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare what you offer in March 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the January 2026 menu or service list, January 26, 2026",
        "href": "/blog/january-list-2026-2026-01-26"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "easter-hours-2026-2026-03-30",
    "title": "Write Easter week hours as special hours, March 30, 2026",
    "seoTitle": "Easter week hours (salon, March 30, 2026)",
    "description": "Easter week hours for a salon on March 30, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-03-30",
    "cta": "This week, look at Easter week hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Easter week in 2026 is not a normal week. Mark the day you close, and leave the rest of the weekly schedule as the days you are open.",
          "This March 30, 2026 note is for a salon. The check is Easter week hours: Easter week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Easter week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Easter week hours. In March 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Easter week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Easter week hours before you add anything",
        "paragraphs": [
          "A mismatch on Easter week hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Easter week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one March 2026 photo of the real place, March 9, 2026",
        "href": "/blog/march-photo-2026-2026-03-09"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "april-hours-2026-2026-04-06",
    "title": "Read the April 2026 hours on the door and the listing, April 6, 2026",
    "seoTitle": "April 2026 hours (clinic, April 6, 2026)",
    "description": "April 2026 hours for a clinic on April 6, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-04-06",
    "cta": "This week, look at the hours for April 2026. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In April 2026, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This April 6, 2026 note is for a clinic. The check is April 2026 hours: the hours for April 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for April 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for April 2026. In April 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for April 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for April 2026 before you add anything",
        "paragraphs": [
          "A mismatch on April 2026 hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the hours for April 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Easter week hours as special hours, March 30, 2026",
        "href": "/blog/easter-hours-2026-2026-03-30"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "april-photo-2026-2026-04-13",
    "title": "Add one April 2026 photo of the real place, April 13, 2026",
    "seoTitle": "April 2026 business photo (restaurant, April 13, 2026)",
    "description": "April 2026 business photo for a restaurant on April 13, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-04-13",
    "cta": "This week, look at a photo from April 2026. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this April of the door, the work, or the counter. A photo from another season makes 2026 look unattended.",
          "This April 13, 2026 note is for a restaurant. The check is April 2026 business photo: a photo from April 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from April 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from April 2026. In April 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from April 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from April 2026 before you add anything",
        "paragraphs": [
          "A mismatch on April 2026 business photo is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare a photo from April 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the April 2026 hours on the door and the listing, April 6, 2026",
        "href": "/blog/april-hours-2026-2026-04-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "april-offer-2026-2026-04-20",
    "title": "Keep the April 2026 offer to a single dated line, April 20, 2026",
    "seoTitle": "April 2026 offer (law office, April 20, 2026)",
    "description": "April 2026 offer for a law office on April 20, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-04-20",
    "cta": "This week, look at the offer running in April 2026. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in April 2026, put the end date in the same sentence and keep it under the phone number.",
          "This April 20, 2026 note is for a law office. The check is April 2026 offer: the offer running in April 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in April 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in April 2026. In April 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in April 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in April 2026 before you add anything",
        "paragraphs": [
          "A mismatch on April 2026 offer is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the offer running in April 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the March 2026 offer to a single dated line, March 16, 2026",
        "href": "/blog/march-offer-2026-2026-03-16"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "april-list-2026-2026-04-27",
    "title": "Update the April 2026 menu or service list, April 27, 2026",
    "seoTitle": "April 2026 service list (retail shop, April 27, 2026)",
    "description": "April 2026 service list for a retail shop on April 27, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-04-27",
    "cta": "This week, look at what you offer in April 2026. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The list should be what you can do this April, typed out so a phone can read it. Remove anything 2026 has already dropped.",
          "This April 27, 2026 note is for a retail shop. The check is April 2026 service list: what you offer in April 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what you offer in April 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what you offer in April 2026. In April 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What you offer in April 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what you offer in April 2026 before you add anything",
        "paragraphs": [
          "A mismatch on April 2026 service list is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare what you offer in April 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the March 2026 menu or service list, March 23, 2026",
        "href": "/blog/march-list-2026-2026-03-23"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "mother-hours-2026-2026-05-04",
    "title": "Say how Mother's Day bookings work this year, May 4, 2026",
    "seoTitle": "Mother's Day bookings (contractor, May 4, 2026)",
    "description": "Mother's Day bookings for a contractor on May 4, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-05-04",
    "cta": "This week, look at Mother's Day bookings. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The week of Mother's Day in 2026 fills early for a lot of shops. Say whether you are taking reservations, walk-ins, or neither, and the hour you stop.",
          "This May 4, 2026 note is for a contractor. The check is Mother's Day bookings: Mother's Day bookings, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Mother's Day bookings",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Mother's Day bookings. In May 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Mother's Day bookings on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Mother's Day bookings before you add anything",
        "paragraphs": [
          "A mismatch on Mother's Day bookings is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Mother's Day bookings. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one April 2026 photo of the real place, April 13, 2026",
        "href": "/blog/april-photo-2026-2026-04-13"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "may-categories-2026-05-11",
    "title": "Check the listing category before summer, May 11, 2026",
    "seoTitle": "Google listing category (salon, May 11, 2026)",
    "description": "Google listing category for a salon on May 11, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-05-11",
    "cta": "This week, look at the primary category. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The category should name the work you want this summer, not a side service. Extra categories have to be true too.",
          "This May 11, 2026 note is for a salon. The check is Google listing category: the primary category, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the primary category",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the primary category. In May 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The primary category on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the primary category before you add anything",
        "paragraphs": [
          "A mismatch on Google listing category is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the primary category. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how Mother's Day bookings work this year, May 4, 2026",
        "href": "/blog/mother-hours-2026-2026-05-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "may-city-list-2026-05-18",
    "title": "Name the cities you will drive to this season, May 18, 2026",
    "seoTitle": "Cities you serve (clinic, May 18, 2026)",
    "description": "Cities you serve for a clinic on May 18, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-05-18",
    "cta": "This week, look at the cities you will take this season. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Travel range changes when the calendar fills. List the places you will go, not every town in the county.",
          "This May 18, 2026 note is for a clinic. The check is cities you serve: the cities you will take this season, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the cities you will take this season",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the cities you will take this season. In May 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The cities you will take this season on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the cities you will take this season before you add anything",
        "paragraphs": [
          "A mismatch on cities you serve is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the cities you will take this season. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Check the listing category before summer, May 11, 2026",
        "href": "/blog/may-categories-2026-05-11"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "memorial-hours-2026-2026-05-25",
    "title": "Mark Memorial Day on the listing, May 25, 2026",
    "seoTitle": "Memorial Day hours (restaurant, May 25, 2026)",
    "description": "Memorial Day hours for a restaurant on May 25, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-05-25",
    "cta": "This week, look at Memorial Day hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Memorial Day 2026 is a Monday. If you are closed, the weekly Monday hours will still look open unless you add a special hour.",
          "This May 25, 2026 note is for a restaurant. The check is Memorial Day hours: Memorial Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Memorial Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Memorial Day hours. In May 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Memorial Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Memorial Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Memorial Day hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Memorial Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Name the cities you will drive to this season, May 18, 2026",
        "href": "/blog/may-city-list-2026-05-18"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "june-starting-price-2026-06-01",
    "title": "Put the current starting price on the page, June 1, 2026",
    "seoTitle": "Starting price (law office, June 1, 2026)",
    "description": "Starting price for a law office on June 1, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-06-01",
    "cta": "This week, look at the starting price. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you quote a starting point on the phone, the page should quote it too. A blank 'call for pricing' on everything is a weaker page.",
          "This June 1, 2026 note is for a law office. The check is starting price: the starting price, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the starting price",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the starting price. In June 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The starting price on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the starting price before you add anything",
        "paragraphs": [
          "A mismatch on starting price is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the starting price. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the April 2026 offer to a single dated line, April 20, 2026",
        "href": "/blog/april-offer-2026-2026-04-20"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "june-cellular-test-2026-06-08",
    "title": "Load the site on a phone off Wi-Fi, June 8, 2026",
    "seoTitle": "Mobile page speed (retail shop, June 8, 2026)",
    "description": "Mobile page speed for a retail shop on June 8, 2026. What to check so the website and Google listing agree.",
    "section": "Site speed",
    "date": "2026-06-08",
    "cta": "This week, look at how fast the page opens on cellular. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Summer customers are in a car or on a sidewalk. If the first screen takes most of a minute, they call someone else.",
          "This June 8, 2026 note is for a retail shop. The check is mobile page speed: how fast the page opens on cellular, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how fast the page opens on cellular",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how fast the page opens on cellular. In June 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How fast the page opens on cellular on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how fast the page opens on cellular before you add anything",
        "paragraphs": [
          "A mismatch on mobile page speed is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare how fast the page opens on cellular. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Know which calls came from the listing, July 21, 2025",
        "href": "/blog/july-tracking-2025-07-21"
      },
      {
        "title": "Core Web Vitals for a Local Service Business",
        "href": "/blog/core-web-vitals-for-a-local-service-business"
      }
    ]
  },
  {
    "slug": "father-hours-2026-2026-06-15",
    "title": "Set Father's Day week hours and capacity, June 15, 2026",
    "seoTitle": "Father's Day hours (contractor, June 15, 2026)",
    "description": "Father's Day hours for a contractor on June 15, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-06-15",
    "cta": "This week, look at Father's Day week. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If Father's Day 2026 changes the book or the menu, put the hours and the limit on the listing. Take it down the next week.",
          "This June 15, 2026 note is for a contractor. The check is Father's Day hours: Father's Day week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Father's Day week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Father's Day week. In June 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Father's Day week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Father's Day week before you add anything",
        "paragraphs": [
          "A mismatch on Father's Day hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Father's Day week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Memorial Day on the listing, May 25, 2026",
        "href": "/blog/memorial-hours-2026-2026-05-25"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "large-photo-files-2026-06-22",
    "title": "Shrink the photo that makes the page wait, June 22, 2026",
    "seoTitle": "Oversized photo (salon, June 22, 2026)",
    "description": "Oversized photo for a salon on June 22, 2026. What to check so the website and Google listing agree.",
    "section": "Site speed",
    "date": "2026-06-22",
    "cta": "This week, look at the photo slowing the page. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "One huge picture of the shop is a common reason a phone spins. Use a smaller image of the same place.",
          "This June 22, 2026 note is for a salon. The check is oversized photo: the photo slowing the page, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the photo slowing the page",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the photo slowing the page. In June 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The photo slowing the page on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the photo slowing the page before you add anything",
        "paragraphs": [
          "A mismatch on oversized photo is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the photo slowing the page. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Load the site on a phone off Wi-Fi, June 8, 2026",
        "href": "/blog/june-cellular-test-2026-06-08"
      },
      {
        "title": "Core Web Vitals for a Local Service Business",
        "href": "/blog/core-web-vitals-for-a-local-service-business"
      }
    ]
  },
  {
    "slug": "july4-hours-2026-2026-06-29",
    "title": "Write July 4 hours before the weekend, June 29, 2026",
    "seoTitle": "July 4 hours (clinic, June 29, 2026)",
    "description": "July 4 hours for a clinic on June 29, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-06-29",
    "cta": "This week, look at July 4 hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Set July 4, 2026 hours on the profile. A short summary in search can repeat an old hour, so the profile has to be the one that is right.",
          "This June 29, 2026 note is for a clinic. The check is July 4 hours: July 4 hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at July 4 hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at July 4 hours. In June 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "July 4 hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix July 4 hours before you add anything",
        "paragraphs": [
          "A mismatch on July 4 hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare July 4 hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Father's Day week hours and capacity, June 15, 2026",
        "href": "/blog/father-hours-2026-2026-06-15"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july-hours-2026-2026-07-06",
    "title": "Read the July 2026 hours on the door and the listing, July 6, 2026",
    "seoTitle": "July 2026 hours (restaurant, July 6, 2026)",
    "description": "July 2026 hours for a restaurant on July 6, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-07-06",
    "cta": "This week, look at the hours for July 2026. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In July 2026, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This July 6, 2026 note is for a restaurant. The check is July 2026 hours: the hours for July 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for July 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for July 2026. In July 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for July 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for July 2026 before you add anything",
        "paragraphs": [
          "A mismatch on July 2026 hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the hours for July 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write July 4 hours before the weekend, June 29, 2026",
        "href": "/blog/july4-hours-2026-2026-06-29"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july-photo-2026-2026-07-13",
    "title": "Add one July 2026 photo of the real place, July 13, 2026",
    "seoTitle": "July 2026 business photo (law office, July 13, 2026)",
    "description": "July 2026 business photo for a law office on July 13, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-07-13",
    "cta": "This week, look at a photo from July 2026. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this July of the door, the work, or the counter. A photo from another season makes 2026 look unattended.",
          "This July 13, 2026 note is for a law office. The check is July 2026 business photo: a photo from July 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from July 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from July 2026. In July 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from July 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from July 2026 before you add anything",
        "paragraphs": [
          "A mismatch on July 2026 business photo is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare a photo from July 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the July 2026 hours on the door and the listing, July 6, 2026",
        "href": "/blog/july-hours-2026-2026-07-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july-offer-2026-2026-07-20",
    "title": "Keep the July 2026 offer to a single dated line, July 20, 2026",
    "seoTitle": "July 2026 offer (retail shop, July 20, 2026)",
    "description": "July 2026 offer for a retail shop on July 20, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-07-20",
    "cta": "This week, look at the offer running in July 2026. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in July 2026, put the end date in the same sentence and keep it under the phone number.",
          "This July 20, 2026 note is for a retail shop. The check is July 2026 offer: the offer running in July 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in July 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in July 2026. In July 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in July 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in July 2026 before you add anything",
        "paragraphs": [
          "A mismatch on July 2026 offer is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the offer running in July 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put the current starting price on the page, June 1, 2026",
        "href": "/blog/june-starting-price-2026-06-01"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "july-list-2026-2026-07-27",
    "title": "Update the July 2026 menu or service list, July 27, 2026",
    "seoTitle": "July 2026 service list (contractor, July 27, 2026)",
    "description": "July 2026 service list for a contractor on July 27, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-07-27",
    "cta": "This week, look at what you offer in July 2026. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The list should be what you can do this July, typed out so a phone can read it. Remove anything 2026 has already dropped.",
          "This July 27, 2026 note is for a contractor. The check is July 2026 service list: what you offer in July 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what you offer in July 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what you offer in July 2026. In July 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What you offer in July 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what you offer in July 2026 before you add anything",
        "paragraphs": [
          "A mismatch on July 2026 service list is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare what you offer in July 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the April 2026 menu or service list, April 27, 2026",
        "href": "/blog/april-list-2026-2026-04-27"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "august-hours-2026-2026-08-03",
    "title": "Read the August 2026 hours on the door and the listing, August 3, 2026",
    "seoTitle": "August 2026 hours (salon, August 3, 2026)",
    "description": "August 2026 hours for a salon on August 3, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-08-03",
    "cta": "This week, look at the hours for August 2026. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In August 2026, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This August 3, 2026 note is for a salon. The check is August 2026 hours: the hours for August 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for August 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for August 2026. In August 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for August 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for August 2026 before you add anything",
        "paragraphs": [
          "A mismatch on August 2026 hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the hours for August 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one July 2026 photo of the real place, July 13, 2026",
        "href": "/blog/july-photo-2026-2026-07-13"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-hours-2026-2026-08-10",
    "title": "Publish back-to-school hours the week they start, August 10, 2026",
    "seoTitle": "Back-to-school hours (clinic, August 10, 2026)",
    "description": "Back-to-school hours for a clinic on August 10, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-08-10",
    "cta": "This week, look at back-to-school hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "School schedules in 2026 change the rush hour. Write the hours you will keep once classes start, on the listing and the page.",
          "This August 10, 2026 note is for a clinic. The check is back-to-school hours: back-to-school hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at back-to-school hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at back-to-school hours. In August 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Back-to-school hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix back-to-school hours before you add anything",
        "paragraphs": [
          "A mismatch on back-to-school hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare back-to-school hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the August 2026 hours on the door and the listing, August 3, 2026",
        "href": "/blog/august-hours-2026-2026-08-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "august-photo-2026-2026-08-17",
    "title": "Add one August 2026 photo of the real place, August 17, 2026",
    "seoTitle": "August 2026 business photo (restaurant, August 17, 2026)",
    "description": "August 2026 business photo for a restaurant on August 17, 2026. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2026-08-17",
    "cta": "This week, look at a photo from August 2026. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this August of the door, the work, or the counter. A photo from another season makes 2026 look unattended.",
          "This August 17, 2026 note is for a restaurant. The check is August 2026 business photo: a photo from August 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from August 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from August 2026. In August 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from August 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from August 2026 before you add anything",
        "paragraphs": [
          "A mismatch on August 2026 business photo is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare a photo from August 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish back-to-school hours the week they start, August 10, 2026",
        "href": "/blog/school-hours-2026-2026-08-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "august-offer-2026-2026-08-24",
    "title": "Keep the August 2026 offer to a single dated line, August 24, 2026",
    "seoTitle": "August 2026 offer (law office, August 24, 2026)",
    "description": "August 2026 offer for a law office on August 24, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-08-24",
    "cta": "This week, look at the offer running in August 2026. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in August 2026, put the end date in the same sentence and keep it under the phone number.",
          "This August 24, 2026 note is for a law office. The check is August 2026 offer: the offer running in August 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in August 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in August 2026. In August 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in August 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in August 2026 before you add anything",
        "paragraphs": [
          "A mismatch on August 2026 offer is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the offer running in August 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the July 2026 offer to a single dated line, July 20, 2026",
        "href": "/blog/july-offer-2026-2026-07-20"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "august-list-2026-2026-08-31",
    "title": "Update the August 2026 menu or service list, August 31, 2026",
    "seoTitle": "August 2026 service list (retail shop, August 31, 2026)",
    "description": "August 2026 service list for a retail shop on August 31, 2026. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2026-08-31",
    "cta": "This week, look at what you offer in August 2026. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The list should be what you can do this August, typed out so a phone can read it. Remove anything 2026 has already dropped.",
          "This August 31, 2026 note is for a retail shop. The check is August 2026 service list: what you offer in August 2026, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what you offer in August 2026",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what you offer in August 2026. In August 2026 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What you offer in August 2026 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what you offer in August 2026 before you add anything",
        "paragraphs": [
          "A mismatch on August 2026 service list is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare what you offer in August 2026. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2026 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the July 2026 menu or service list, July 27, 2026",
        "href": "/blog/july-list-2026-2026-07-27"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  }
];
